module.exports = __webpack_public_path__ + "img/website-applications.52f36f95.svg";